import type { z } from 'zod'
import type { LowerHex, TransactionDecoded } from '../../../../types'
import type { addressInSchema } from './schema'

export const checkValueIsAddressIn = ({
  value,
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly value: string
  readonly schema: z.infer<typeof addressInSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): boolean => {
  const valuesSet = getAddressInValues({
    schema,
    transaction,
    relatedAddresses,
  })
  if (schema.not === true) {
    return !valuesSet.has(value)
  }
  return valuesSet.has(value)
}

const getAddressInValues = ({
  schema,
  transaction,
  relatedAddresses,
}: {
  readonly schema: z.infer<typeof addressInSchema>
  readonly transaction: TransactionDecoded
  readonly relatedAddresses: Set<LowerHex>
}): Set<string> => {
  const set = new Set<string>()

  for (const value of schema.values) {
    if (value === 'related') {
      for (const address of relatedAddresses) {
        set.add(address)
      }
      continue
    }
    if (value === 'from') {
      set.add(transaction.from.address)
      continue
    }
    if (value === 'to') {
      set.add(transaction.to?.address ?? '')
      continue
    }
    set.add(value)
  }

  return set
}
